// extracted by mini-css-extract-plugin
export default {"Header":"header_Header__t-F3X","Text":"header_Text__wW4Fv","Icon":"header_Icon__zqvRD"};